<template>
  <el-card id="form-edit" v-loading="loading" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{data.judul}}</span>
    </div>
<el-form v-if="role == 'admin'" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="Nama">
        <el-input v-model="formInline.nama" placeholder="Nama"></el-input>
      </el-form-item>
      <el-form-item label="Keterangan">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5}"
          placeholder="Keterangan"
          v-model="formInline.keterangan">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">Simpan</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      :default-sort="{prop: 'nama', order: 'ascending'}"
      empty-text="tidak ada data">
      <el-table-column
        prop="nama"
        label="Nama"
        width="180">
      </el-table-column>
      <el-table-column
        prop="keterangan"
        label="Keterangan">
      </el-table-column>
      <el-table-column
        align="right"
        fixed="right"
        v-if="role == 'admin'">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row)">Edit</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)">Hapus</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>

</template>

<script>
import { database } from '../firebase'

export default {
  data() {
    return {
      data: {
        judul: 'memuat . . .',
        data: {
          'memuat . . .': ''
        },
      },
      tableData: [],
      formInline: {
        nama: '',
        keterangan: ''
      },
      loading: false,
      role: this.$store.state.user.displayName
    }
  },
  mounted() {
    let glosarium_ref = database.ref('isi/glosarium') 
    glosarium_ref.on('value', (snapshot) => {
      this.tableData = []
    
      this.data = snapshot.val()
      for (let i in this.data.data) {
        this.tableData.push({
          nama: i,
          keterangan: this.data.data[i]
        })      
      }
    })
  },
  methods: {
    onSubmit() {
      this.loading = true
      var update = {}
      update['isi/glosarium/data/'+this.formInline.nama] = this.formInline.keterangan
      database.ref().update(update).then(()=>{
        this.loading = false;
        this.$notify({
          title: 'Sukses',
          message: '"' + this.formInline.nama + '" telah tersimpan',
          type: 'success'
        })
        this.formInline.nama = ''
        this.formInline.keterangan = ''
      }).catch((error) => {
        this.loading = false
        this.$notify.error({
          title: 'Error',
          message: error
        });
      })
    },
    handleEdit(row) {
      this.formInline.nama = row.nama 
      this.formInline.keterangan = row.keterangan
      document.getElementById('form-edit').scrollIntoView()
    },
    handleDelete(row) {
      this.$confirm('Apakah anda yakin akan menghapus "'+row.nama+'"' , 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(() => {
          let glosarium_ref = database.ref('isi/glosarium/data/'+row.nama)
          glosarium_ref.remove()
            .then(() => {
              this.$notify({
                title: 'Sukses',
                message: '"'+ row.nama + '" telah dihapus',
                type: 'success'
              })
            })
            .catch((error) => {
              this.$message({
                type: 'error',
                message: 'Gagal menghapus ('+error+')'
              });
            })
        })
      
    }
  }
}
</script>

